import { TASK_ITEMS } from "_constants/reducers.constants";
import toDetails from "./toDetails";

const skuCard =  {
  [TASK_ITEMS.TO_DETAILS]: toDetails,
};

export default skuCard;
